import React from 'react'

import { PageHeader, Button } from 'antd'

import { Link } from 'react-router-dom'
import { PROJECT_MANAGER } from '../../../../redux/actions/config/session'

import RestrictedView from '../../../../core/components/auth/restrictedView'

import { LAYOUT_MANAGER_USER_SHOW, LAYOUT_MANAGER_JOB_NEW, LAYOUT_MANAGER_HOME_EVENT } from '../../navigation'

import Loader from '../../../../components/loader'
import { IdcardOutlined, BellOutlined } from '@ant-design/icons'

import Dashboard from './dashboard'
import Filters from './filters'

import { decodeQueryFromURL, onFilterChangeUpdateUrl } from '../../../../core/utils/list'

class Container extends React.Component {
  constructor(props) {
    super(props)

    const defaultValues = { active: 1 }

    this.state = { defaultValues }
  }

  componentDidUpdate(prevProps) {
    const { history } = this.props

    if (history.location.search !== prevProps.location.search) {
      const query = decodeQueryFromURL(history, this.state.defaultValues)

      //this.props.loadTasksForHome(query)
    }
  }

  _onFilterChangeUpdateUrl = (form) => onFilterChangeUpdateUrl(this.props.history, form)

  render () {
    const parameters = decodeQueryFromURL(this.props.history, this.state.defaultValues)
    return (
      <RestrictedView allowedRoles={PROJECT_MANAGER}>
        <>
          <PageHeader
            ghost={false}
            title={<>Welcome</>}
            extra={[
              <Link to={LAYOUT_MANAGER_USER_SHOW} key='1' disabled>
                <Button size='small' icon={<IdcardOutlined />}>
                  Settings
                </Button>
              </Link>,
              <Link to={LAYOUT_MANAGER_HOME_EVENT} key='2' disabled>
                <Button size='small' icon={<BellOutlined />} />
              </Link>,
              <Link to={LAYOUT_MANAGER_JOB_NEW} key='3'>
                <Button size='small' type='primary' icon={<IdcardOutlined />}>
                  New Job
                </Button>
              </Link>
            ]}
          >
            <Filters filters={parameters} onUpdateFilters={this._onFilterChangeUpdateUrl} />

          </PageHeader>
          <Loader loading={this.props.loading} />
          <br />

          <Dashboard query={parameters} />
        </>
      </RestrictedView>
    )
  }
}

export default Container
